import SVG from "../../../Components/SVG";
import { Tooltip } from "react-tooltip";

export default function ProfitGridCard({
  id,
  uuid,
  accountType,
  accountProfit,
  profitAvailable,
  processTime,
  isLocked,
  lockReason,
  onWithdraw,
}) {
  const tooltipId = `payoutGridLockReasonTooltip-${id}`;

  return (
    <article className="w-full rounded-2xl p-2.5 flex flex-col gap-3 bg-gradient-to-br from-white/10 to-white/5 border border-white/10">
      <div className="w-full flex items-center justify-between gap-2.5">
        <div className="flex flex-col gap-0 items-start">
          <span className="text-xs font-thin text-zi-text-light/50 dark:text-zi-text-dark/50">
            کد حساب
          </span>
          <span className="text-sm text-zi-text-light dark:text-zi-text-dark">
            {uuid}
          </span>
        </div>
        <div className="flex flex-col gap-0 items-end">
          <span className="text-xs font-thin text-zi-text-light/50 dark:text-zi-text-dark/50">
            نوع حساب
          </span>
          <span className="text-sm text-zi-text-light dark:text-zi-text-dark">
            {accountType}
          </span>
        </div>
      </div>
      <div className="w-full flex items-center justify-between gap-2.5">
        <div className="flex flex-col gap-0 items-start">
          <span className="text-xs font-thin text-zi-text-light/50 dark:text-zi-text-dark/50">
            سود حساب
          </span>
          <span className="text-sm text-zi-text-light dark:text-zi-text-dark">
            {accountProfit}
          </span>
        </div>
        <div className="flex flex-col gap-0 items-end">
          <span className="text-xs font-thin text-zi-text-light/50 dark:text-zi-text-dark/50">
            سود قابل برداشت
          </span>
          <span className="text-sm text-zi-text-light dark:text-zi-text-dark">
            {profitAvailable}
          </span>
        </div>
      </div>
      <div className="w-full flex items-center justify-between gap-2.5">
        <div className="w-full flex flex-col gap-0 items-start">
          <span className="text-xs font-thin text-zi-text-light/50 dark:text-zi-text-dark/50">
            زمان تقریبی پردازش
          </span>
          <span className="text-xs text-zi-text-light/75 dark:text-zi-text-dark/75">
            {processTime}
          </span>
        </div>
        <button
          type="button"
          data-tooltip-id={isLocked ? tooltipId : undefined}
          data-tooltip-content={isLocked ? lockReason : undefined}
          className={`w-full pt-1 pb-2 flex items-center justify-center gap-2 text-sm text-zi-text-dark rounded-lg ${isLocked ? "bg-transparent border border-dashed border-zi-border-light/30" : "bg-zi-buttonbg-primary"}`}
          onClick={isLocked ? undefined : onWithdraw}
        >
          {isLocked ? (
            <>
              <SVG name="lock" classname="size-5 stroke-zi-text-dark" />
              علت
              <Tooltip
                id={tooltipId}
                place="bottom"
                className="z-50 !py-1 !px-2 !text-xs !font-thin !backdrop-blur !bg-cyan-600 !rounded-lg"
              />
            </>
          ) : (
            "درخواست برداشت"
          )}
        </button>
      </div>
    </article>
  );
}
